export enum TypeViewEnum {
  TABLE = 'table',
  CARD = 'card'
}
